import { createSelector } from 'reselect';

const selectNotif = (state) => state.notif;
export const selectInvoiceNotifications = (state) =>
    state.notif.invoiceNotifications;

export const selectShowInvoicesNotif = createSelector(
    selectInvoiceNotifications,
    (invoiceNotifs) => invoiceNotifs && Object.keys(invoiceNotifs).length > 0
);

export { selectNotif };
